module.exports = __webpack_public_path__ + "static/media/premium.5b65bb88.jpeg";